import { List, Segment } from 'semantic-ui-react';

const GenericList = (props) => {

  const { formData } = props

  let listProps = formData

  const lister = () => {
    const items = []
    const count = 10
    for (var i = 1; i <= count; ++i) {
      items.push(<List.Item>{'Item ' + i}</List.Item>)
    }
    return <Segment basic inverted >
      <List inverted fluid {...listProps} >
        {items}
      </List>
    </Segment>
  }

  return lister()
}

export default GenericList